export const BREAKPOINTS = {
  mobile: 744,
  smallMobile: 520,
  tablet: 768,
  desktop: 1024
}
